import { createSlice } from '@reduxjs/toolkit';
import { handleGetTags } from './tagThunk';
import { ITags } from '~/utils/interface/tag';

export interface tagState {
  tags: ITags;
}

const initialState: tagState = {
  tags: [],
};

const tagSlice = createSlice({
  name: 'tag',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(handleGetTags.pending, (_state, _action) => { })
      .addCase(handleGetTags.fulfilled, (state, action) => {
        state.tags = [...action.payload.responses];
      })
      .addCase(handleGetTags.rejected, (_state, _action) => { });
  },
});

export const tagActions = tagSlice.actions;

const tagReducer = tagSlice.reducer;
export default tagReducer;
